import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { VRV_PRODUCTS } from '../data/vrvRange';

// "Choose the Right VRV for Your Space": the three VRV cards from the VRV
// page, used there and on the location pages, so both look the same.
export default function VRVRange() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
      {VRV_PRODUCTS.map((product) => (
        <Card key={product.name} className="border-none shadow-xl bg-white group hover:-translate-y-2 transition-transform duration-300 overflow-hidden rounded-2xl">
          <div className="relative overflow-hidden bg-gray-50">
            <img src={product.image} alt={product.alt} loading="lazy" className="w-full h-56 lg:h-72 object-contain p-2" />
            <span className="absolute top-4 left-4 bg-white text-blue-700 text-[10px] lg:text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-md border border-gray-100 z-10">
              {product.tag}
            </span>
          </div>
          <CardContent className="p-5 lg:p-8">
            <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-2 lg:mb-3">{product.name}</h3>
            <p className="text-sm lg:text-base text-gray-600 mb-5 lg:mb-6 leading-relaxed font-medium lg:min-h-[48px]">{product.desc}</p>

            <ul className="space-y-2.5 lg:space-y-3 mb-5 lg:mb-6">
              {product.features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 lg:gap-3 text-xs lg:text-sm font-medium text-gray-700">
                  <CheckCircle className="text-blue-500 flex-shrink-0 mt-0.5" size={16} />
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <div className="pt-4 border-t border-gray-100">
              <p className="text-[11px] lg:text-xs text-gray-500 leading-relaxed"><span className="font-bold text-blue-600 uppercase tracking-wide block mb-1">Ideal for:</span> {product.ideal}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
